module.exports = __webpack_public_path__ + "img/40_38_048_170.18238e70.jpg";